<script>
    import { onMount, onDestroy, beforeUpdate } from 'svelte';
    import {db} from '../firestore';
    import Card from '../components/ui/Card.svelte';
    import Image from '../components/display/Image.svelte';
    import { currentTenant } from '../stores/tenant.js';
    import { currentProduct } from '../stores/product.js';
    import { navigateTo, routeIsActive } from 'svelte-router-spa'


    import { getIndexByAttr } from '../helper/ListExtensions.js';
    import { Navigate } from 'svelte-router-spa'
    //---------- Props ----------//
    export let isOpen = false;

    const handleEscape = (e) => {
        if (e.key === 'Esc' || e.key === 'Escape') {
            isOpen = false;
        }
    }


let products = [];
let productListener;
let firstCall = true;

onMount(()=>{
    document.addEventListener('keydown', handleEscape);

     productListener = db.collection("tenants").doc($currentTenant.tid).collection("products").onSnapshot({ includeMetadataChanges: false },(querySnapshot) => {
        const newProductAdded = products.length != querySnapshot.length;
        const tmpProducts = JSON.parse(JSON.stringify(products));
        products = [];
        
        querySnapshot.forEach(doc => {
            let product = doc.data();
            product['uid'] = doc.id;
            
            if(firstCall){
                if(routeIsActive(`product/`, true)){ //Check if init URL contains product
                    if(routeIsActive(`product/${product.uid}`, true)){ //Set product passed by URL as active one
                        currentProduct.setProduct(product);
                        firstCall = false;
                    }
                }
                 else{ //If non product URL on init, select first entry as current Product
                    currentProduct.setProduct(product);
                    firstCall = false;
                 }            
            }

            // if(newProductAdded){ //TODO -> not on first call -> onSnapshot is called twice on init -> WHY
            //     if(getIndexByAttr(tmpProducts, 'uid', product.uid) == -1){
            //        // currentProduct.setProduct(product);
            //       //  goToProduct();
            //     }
            // }
            if(!firstCall){
                if($currentProduct.uid == product.uid){
                    currentProduct.setProduct(product);
                }
            }
            products = [...products, product];
        });
    });

});

 onDestroy(()=>{
     if(typeof productListener == 'function'){
        productListener();
     }
})

function changeProduct(product){
    currentProduct.setProduct(product);
    goToProduct();
}

function goToProduct(){
    console.log($currentProduct);
    navigateTo(`/product/${$currentProduct.uid}/product-details`);
}

const createNew = ()=>{
        navigateTo(`/createproduct`);

}

</script>

{#if $currentTenant}

<div class="relative w-full">
    {#if $currentProduct}
    <div class="relative flex items-center cursor-pointer" on:click|stopPropagation|preventDefault={() => {isOpen = !isOpen}} style="color:#D1D3D4;">
                {#if $currentProduct.logo == null}
                <svg class="mr-3 h-6 w-6 text-gray-300 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                    <path d="M12.42,14.06V24h9.94V14.06ZM0,24H9.94V14.06H0ZM0,1.63v9.94H9.94V1.63ZM17,0l-7,7,7,7,7-7Z" fill="#D1D3D4"/>            
                </svg>
                {:else}
                <Image src={$currentProduct.logo} class="mr-3 h-6 w-6 transition ease-in-out duration-150"/>
                {/if}
                <span class="flex-grow">{$currentProduct.name}</span>
                <span>&#9660;</span>

    </div>
    {:else}
    <div class="relative z-10 flex items-center cursor-pointer text-white hover:bg-smfBlack-200" style="color:#D1D3D4;">
     <svg class="mr-4 h-6 w-6 text-gray-300 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                    <path d="M12.42,14.06V24h9.94V14.06ZM0,24H9.94V14.06H0ZM0,1.63v9.94H9.94V1.63ZM17,0l-7,7,7,7,7-7Z" fill="#D1D3D4"/>            
                </svg>
     <Navigate to="/createProduct">Create 1st product
     </Navigate>
    </div>
    {/if}

    <!-- PopUp Menu -->
    {#if isOpen}
    <button on:click={() => {isOpen = false}} tabindex="-1" class="fixed inset-0 h-full w-full cursor-default"></button>
    <div on:click={() => {isOpen = false}} class="absolute -left-4 mt-2 w-64 shadow-2xl bg-smfBlack-100">
        {#each products as product}
            <button type="button" class="block px-4 py-2 w-full hover:bg-smfBlack-200 text-left flex flex-row" on:click={() => {changeProduct(product)}} style="color:#8D8D8D;">
                {#if product.logo == null}
                <svg class="mr-4 h-6 w-6 text-gray-300 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                    <path d="M12.42,14.06V24h9.94V14.06ZM0,24H9.94V14.06H0ZM0,1.63v9.94H9.94V1.63ZM17,0l-7,7,7,7,7-7Z" fill="#D1D3D4"/>            
                </svg>
                {:else}
                <Image src={product.logo} class="mr-4 h-6 w-6 transition ease-in-out duration-150"/>
                {/if}                
                <span>{product.name}</span>
            </button>
        {/each}
        <div class="border-t border-gray-100"></div>
        <button type="button" class="block px-4 py-2 w-full hover:bg-smfBlack-200 text-left flex flex-row" on:click={createNew} style="color:#8D8D8D;">
                <svg class="mr-4 h-6 w-6 text-gray-300 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                    <path d="M12.42,14.06V24h9.94V14.06ZM0,24H9.94V14.06H0ZM0,1.63v9.94H9.94V1.63ZM17,0l-7,7,7,7,7-7Z" fill="#D1D3D4"/>            
                </svg>
                <span>Add Product</span>
        </button>
    </div>
    {/if}
</div>
{/if}
